













































import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { ORDER_BY_DIRECTION_LIST } from '@/constants/filter';
import _ from 'lodash';

@Component({})
export default class BusinessListFilterForm extends Vue {
  @PropSync('options') optionsSynced!: BusinessListFilterOptions;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;

  directionList = ORDER_BY_DIRECTION_LIST;

  optionsLocal: BusinessListFilterOptions = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: null,
    orderByDirection: 'asc',
  };

  orderByList = [
    {
      text: 'Name',
      value: 'name',
    },
    {
      text: 'Object ID',
      value: 'object_id',
    },
    {
      text: 'Created At',
      value: 'created_at',
    },
    {
      text: 'Update At',
      value: 'updated_at',
    },
  ];

  isMounted = false;
  directionIcon = 'mdi-sort-ascending';

  mounted() {
    this.cloneOptionsLocal();
    this.isMounted = true;
  }

  @Watch('optionsSynced', { deep: true })
  watchOptionsSynced() {
    this.cloneOptionsLocal();
  }

  cloneOptionsLocal() {
    this.optionsLocal = _.cloneDeep(this.optionsSynced);
    if (this.optionsLocal.orderByDirection == 'asc') {
      this.directionIcon = 'mdi-sort-ascending';
    } else {
      this.directionIcon = 'mdi-sort-descending';
    }
  }

  cloneOptions() {
    this.optionsSynced = _.cloneDeep(this.optionsLocal);
  }

  resetOptions() {
    this.optionsLocal = {
      page: 1,
      itemsPerPage: 10,
      query: null,
      orderBy: null,
      orderByDirection: 'asc',
    };
    this.cloneOptions();
  }

  switchOrderByDirection() {
    if (this.optionsLocal.orderByDirection == 'asc') {
      this.optionsLocal.orderByDirection = 'desc';
      this.directionIcon = 'mdi-sort-descending';
    } else {
      this.optionsLocal.orderByDirection = 'asc';
      this.directionIcon = 'mdi-sort-ascending';
    }
  }
}
